// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sonic"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 10V14M8 7L8 17M12 3L12 21M16 7L16 17M20 10V14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SonicIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sonic',
    ref,
    icon: element,
  },
));

SonicIcon.displayName = 'SonicIcon';

export default SonicIcon;
